export default __webpack_public_path__ + "static/media/pic3.265f9a2f.png";